import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import { CloudUpload, Close } from "@mui/icons-material";

const photoKeys = [
  "profile_photo",
  "profile_photo1",
  "profile_photo2",
  "profile_photo3",
];

const UploadPhotos = ({ form, handleMultiImageUpload, setField }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Upload Photos (Max 4, JPG/PNG)
      </Typography>

      {/* Single upload button */}
      <Card
        variant="outlined"
        sx={{ borderStyle: "dashed", mb: 2, cursor: "pointer" }}
        onClick={() => document.getElementById("photos-input")?.click()}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <CloudUpload sx={{ fontSize: 44, mb: 1 }} />
          <Typography>Click to choose photos</Typography>
          <input
            id="photos-input"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            multiple
            style={{ display: "none" }}
            onChange={handleMultiImageUpload}
          />
        </CardContent>
      </Card>

      {/* Preview selected photos */}
      <Grid container spacing={2}>
        {photoKeys.map((key, idx) =>
          form[key] ? (
            <Grid item xs={6} sm={3} key={key}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 1,
                  overflow: "hidden",
                }}
              >
                <img
                  src={form[key].url}
                  alt={form[key].name}
                  // onError={(e) => console.error("Image failed:", form[key])}
                  style={{ width: "100%", height: 160, objectFit: "cover" }}
                />
                <IconButton
                  size="small"
                  onClick={() => {
                    setField(key, null);
                  }}
                  sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    bgcolor: "rgba(0,0,0,0.55)",
                    color: "#fff",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </Box>
              <Typography
                variant="caption"
                sx={{ display: "block", mt: 0.5 }}
                noWrap
              >
                {form[key].name}
              </Typography>
            </Grid>
          ) : null,
        )}
      </Grid>

      <Typography variant="body2" sx={{ mt: 1 }}>
        Uploaded: {photoKeys.filter((k) => form[k]).length}/4
      </Typography>
    </Box>
  );
};

export default UploadPhotos;
